import { Laterality } from "../constants";
import { FieldDefinition } from "./fieldDefinitions";

// Α. DTO (Αυτό που έρχεται από το backend)
export interface DiseaseDto {
  readonly icd10Id: string;
  readonly icd10Descr: string;
  readonly icd10Remarks?: string;
  readonly laterality?: string;
}

export const diseaseKeyId = "icd10Id" as const;

// Β. FormData Type (Αυτό που χειρίζεται η φόρμα)
export type DiseaseFormData = {
  icd10Descr: string;
  icd10Remarks?: string;
  laterality?: string;
};

// Γ. Fields με το Generic FieldDefinition<DiseaseFormData>
export const diseaseFields: FieldDefinition<DiseaseFormData>[] = [
  {
    name: "icd10Descr",
    label: "Περιγραφή Ασθένειας",
    type: "text",
    required: true,
  },
  {
    name: "icd10Remarks",
    label: "Παρατηρήσεις",
    type: "text",
    required: false,
  },
  {
    name: "laterality",
    label: "Πλευρικότητα",
    type: "select",
    required: false,
    options: Object.entries(Laterality).map(([value, label]) => ({
      value,
      label: String(label),
    })),
  },
] as const;

export const diseaseFormData = [
  "icd10Descr",
  "icd10Remarks",
  "laterality",
] as const;
